// extracted by mini-css-extract-plugin
export default {"section-marker":"section-marker__2rndj","section-marker__title":"section-marker__title__1-vdI","fade-in":"fade-in__10_jd","fade-out":"fade-out__2IQhv"};